import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01d5b4f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-main" }
const _hoisted_2 = { class: "content-header" }
const _hoisted_3 = { class: "main-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "VAT Categories")
], -1))
const _hoisted_5 = { class: "content-body stretch-height" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CategoryItemComponent = _resolveComponent("CategoryItemComponent")!
  const _component_Scroller = _resolveComponent("Scroller")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_UpdateCreateVItemCategoryForm = _resolveComponent("UpdateCreateVItemCategoryForm")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, [
            _createVNode(_component_a_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createVItemCategory())),
              class: "vItems-add",
              shape: "circle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "plus" })
              ]),
              _: 1
            })
          ]),
          _hoisted_4
        ]),
        _createVNode(_component_Search, {
          items: _ctx.filteredCategories,
          onFiltered: _ctx.filtered,
          searchString: _ctx.filterString
        }, null, 8, ["items", "onFiltered", "searchString"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_row, {
          gutter: 15,
          class: "stretch-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              style: {"padding-bottom":"50px"},
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Scroller, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCategories, (category) => {
                      return (_openBlock(), _createBlock(_component_CategoryItemComponent, {
                        key: `${category.id}`,
                        category: category,
                        onDelete: _ctx.modifiedCategory,
                        onUpdate: _ctx.modifiedCategory
                      }, null, 8, ["category", "onDelete", "onUpdate"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_a_modal, {
            footer: null,
            visible: _ctx.showModal,
            title: 'Create VAT Category',
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancel()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UpdateCreateVItemCategoryForm, {
                category: _ctx.category,
                campaignID: _ctx.campaignID,
                method: "Create",
                onSaved: _ctx.modifiedCategory
              }, null, 8, ["category", "campaignID", "onSaved"])
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}